import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { toast } from 'react-toastify';
import ValidationMessage from '../../../../../../component/common/ValidationMessage';
import ButtonLoader from '../../../../../../component/common/ButtonLoader';
const PriceModuleAddForm = (props) => {

    const {moduleUpdateData} = props;

    const api_base_url = process.env.REACT_APP_API_URL;
    const loginUserType = localStorage.getItem('type');

    // ---- define all state here ----- //
    const [priceModuleFormData, setPriceModuleFormData] = useState({
        module_update_id: "",
        module_old_name: "",
        module_name: "",
        module_price: "",
        module_price_type: "",
        includes: ""
    });
    const [priceModuleFormError, setPriceModuleFormError] = useState({});
    const [saveBtnLoader, setSaveBtnLoader] = useState(false);

    const validateField = (name, value) => {
        let error = "";
        if (name === "module_name") {
            if (!value) {
                error = "Module name is required";
            } 
        }
        if (name === "module_price") {
            if (!value) {
                error = "Price and type is required";
            } 
        }
        if (name === "module_price_type") {
            if (!value) {
                error = "Price and type is required";
            } 
        }
        return error;
    }


    const inputChangeHandler = (selectedOption, actionMeta) => {
        if(selectedOption.target){
            const { name, value } = selectedOption.target;
            const fieldError = validateField(name, value);
            setPriceModuleFormError((prevErrors) => ({
                ...prevErrors,
                [name]: fieldError,
            }));
            setPriceModuleFormData((prevData) => ({
                ...prevData,
                [name]: value,
            }));
        }
    }


    const priceModuleOnSubmit = async (e) => {
        e.preventDefault();
        const newErrors = {};
        for (const key in priceModuleFormData) {
            newErrors[key] = validateField(key, priceModuleFormData[key]);
        }
        setPriceModuleFormError(newErrors);
        if (Object.keys(newErrors).every((key) => !newErrors[key])) {
            // console.log('priceModuleFormData', priceModuleFormData)
            setSaveBtnLoader(true)

            let apiToken = '';
            if(loginUserType === 'A'){
                apiToken = localStorage.getItem('token')
            }
            else if(loginUserType === 'D'){
                apiToken = localStorage.getItem('developertoken')
            }
            else if(loginUserType === 'SA') {
                apiToken = localStorage.getItem('systemAdminToken')
            }

            var api_headers = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "x-access-token" : apiToken
                }
            };

            await axios.post(`${api_base_url}api/save-pricing-module`, priceModuleFormData, api_headers)
            .then(async (res) => {
                if(res.data.status === 'success') {
                    console.log(res)
                    setPriceModuleFormData({
                        module_update_id: "",
                        module_old_name: "",
                        module_name: "",
                        module_price: "",
                        module_price_type: "",
                        includes: ""
                    });
                    setPriceModuleFormError({});
                    toast.success(res.data.message);
                    props.formSubmitted(true)
                } else if(res.data.status === 'error') {
                    toast.error(res.data.message);
                }
                setSaveBtnLoader(false)
            })
            .catch((error) => {
                console.error(error);
                setSaveBtnLoader(false)
            })
        }
    }

    useEffect(() => {
        if((Object.keys(moduleUpdateData).length) === 0) return
        setPriceModuleFormData({
            module_update_id: moduleUpdateData.id,
            module_old_name: moduleUpdateData.module_name,
            module_name: moduleUpdateData.module_name,
            module_price: moduleUpdateData.price,
            module_price_type: moduleUpdateData.price_type,
            includes: moduleUpdateData.includes
        })
        setPriceModuleFormError({})
    },[moduleUpdateData])


    return (
        <div className="card card-flush border" id="user_add_card">
            <div className="card-header py-3">
                <h3 className="card-title align-items-start flex-column">
                    <span className="card-label fw-bold text-gray-800 fs-2">
                        Add Module
                    </span>
                    <span className="text-gray-400 mt-1 fw-semibold fs-6">
                        Total 0 module are available
                    </span>
                </h3>
            </div>
            <div className="card-body pt-0">
                <form onSubmit={priceModuleOnSubmit}>
                    <div className="row">
                        <div className="col-md-12 mb-4">
                            <label className="form-label required">
                                Module Name
                            </label>
                            <input 
                                type="text" 
                                name="module_name" 
                                className="form-control form-control-solid" 
                                placeholder="Enter module name"
                                onChange={inputChangeHandler}
                                value={priceModuleFormData.module_name}
                            />
                            {priceModuleFormError.module_name && 
                                <ValidationMessage 
                                    className='text-danger' 
                                    message ={priceModuleFormError.module_name}
                                />
                            }
                        </div>
                        <div className="col-md-12">
                            <label className="form-label required">
                                Price (US$)
                            </label>
                            <div className="input-group input-group-solid mb-5">
                                <input
                                    style={{borderRight:'3px solid #c3c5c5'}}
                                    type="text" 
                                    className="form-control" 
                                    placeholder="00.00"
                                    name="module_price"
                                    onChange={inputChangeHandler}
                                    value={priceModuleFormData.module_price}
                                />
                                <input
                                    type="text" 
                                    className="form-control" 
                                    placeholder="Month / record"
                                    name="module_price_type"
                                    onChange={inputChangeHandler}
                                    value={priceModuleFormData.module_price_type}
                                />
                            </div>
                            {(priceModuleFormError.module_price || priceModuleFormError.module_price_type) && (
                                <ValidationMessage
                                    className="text-danger"
                                    message={
                                        priceModuleFormError.module_price ||
                                        priceModuleFormError.module_price_type
                                    }
                                />
                            )}
                        </div>
                        <div className="col-md-12">
                            <label className="form-label">
                                Includes
                            </label>
                            <input
                                type="text" 
                                name="includes" 
                                className="form-control form-control-solid" 
                                placeholder="Enter description"
                                onChange={inputChangeHandler}
                                value={priceModuleFormData.includes}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 text-end mt-5">
                            <button 
                                className={`btn btn-dark ${saveBtnLoader && 'disabled'}`} 
                                type="submit"
                            >
                                {
                                    saveBtnLoader ? <ButtonLoader btnHtml='Please wait...' className='me-2'/> : 'Save'
                                }
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    )
}
export default PriceModuleAddForm